<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading" class="flex">
          <div class="form-group">
            <label>Фильтр по статусам</label>
            <select v-model="filter.status" class="form-control">
              <option value="0">Все препараты</option>
              <option v-for="s in storeStatuses" :value="s.id">{{ s.title }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Продажи</label>
            <select v-model="filter.showWithSales" class="form-control">
              <option value="0">Без продаж</option>
              <option value="1">Были продажи</option>
            </select>
          </div>

        </div>
      </div>
    </div>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <p>Всего препаратов: <strong>{{ totalRecords }}</strong></p>
        <div v-if="Object.values(selectedDrug).filter((s) => s).length">
          <p>Выделено препаратов: <strong>{{ Object.values(selectedDrug).filter((s) => s).length }}</strong>
            <button type="button" @click="deselectAll" class="ml-2 btn btn-xs btn-default">отменить выделенные</button>
          </p>
          <div class="flex">
            <select v-model="newStatus" class="form-control w-50">
              <option v-for="s in storeStatuses" :value="s.id">{{ s.title }}</option>
            </select>
            <LoadingButton
              title="Сохранить"
              type="button"
              :loading="saveLoading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => changeStatus()"
              className="btn btn-outline-success close_btn"
            />
          </div>
        </div>
        <table-component
          ref="table"
          :data="getDrugsByFilter()"
          table-class="table">
          <table-column label="" :sortable="false" :filterable="false">
            <template slot-scope="row">
              <input v-model="selectedDrug[row.drug.id]" @change="holdShift(row.drug.id, $event)"
                     type="checkbox">
            </template>
          </table-column>
          <table-column label="ID" show="drug.id" :sortable="false" :filterable="false"/>
          <table-column show="drug.title" label="Препарат"></table-column>
          <table-column show="drug.priority" data-type="numeric" label="Приоритет" :filterable="false"
                        :sortable="false"/>
          <table-column show="inStores" data-type="numeric" label="На складе" :filterable="false"/>
          <table-column show="sales" label="Продажи" data-type="numeric" :filterable="false"/>
          <table-column show="storeData.sorting" label="Остаток">
            <template slot-scope="row">
              <span
                :class="{'badge': true,
                'badge-success': row.storeData.sorting === 2,
                'badge-info': row.storeData.sorting === 1,
                'badge-warning': row.storeData.sorting === 0,
              }">{{ row.storeData.title }}</span>
            </template>
          </table-column>
          <table-column label="статус" :sortable="false" :filterable="false">
            <template slot-scope="row">
              <select @change="changeStatus(row.drug.id, $event)" v-model="row.drug.status" class="form-control">
                <!--                <option value="0">не выбран</option>-->
                <option v-for="s in storeStatuses" :value="s.id">{{ s.title }}</option>
              </select>
            </template>
          </table-column>
        </table-component>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import {TableComponent, TableColumn} from 'vue-table-component';
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  title: 'Статусы препаратов',
  components: {
    LoadingButton,
    TableComponent,
    TableColumn,
  },
  data() {
    return {
      totalRecords: 0,
      isShift: false,
      loading: true,
      saveLoading: false,
      allDrugs: [],
      inStores: {},
      selectedDrug: {},
      sales: {},
      filter: {
        status: 0,
        showWithSales: 1
      },
      newStatus: 1,
      storeStatuses: [
        {id: 1, title: 'ожидается в течение месяца'},
        {id: 2, title: 'ожидается в течение 2-3 месяцев'},
        {id: 3, title: 'в поиске (нет нигде)'},
        {id: 4, title: 'нет спроса'},
        {id: 5, title: 'ожидает оценки'},
      ],
    }
  },
  created() {
    document.onkeydown = (e) => this.updateShiftBtn(e);
    document.onkeyup = (e) => this.updateShiftBtn(e, true);
    this.getDrugs();
  },
  beforeDestroy() {
    document.onkeydown = null;
    document.onkeyup = null;
  },
  methods: {
    deselectAll() {
      this.selectedDrug = {};
    },
    async changeStatus(drugId = null, e = null) {
      let newStatus = this.newStatus;
      let selectedDrugs = Object.keys(this.selectedDrug).filter((d) => this.selectedDrug[d]);
      if (drugId) {
        const drug = this.allDrugs.find((d) => d.id === drugId);
        selectedDrugs = [drug.id];
        newStatus = +e.target.value
      } else {
        this.saveLoading = true;
      }
      const {data} = await api.post('/new/drugs/store/status', {
        action: 'update',
        selected_drugs: selectedDrugs,
        new_status: newStatus
      })
      if (data.success) {
        await this.getDrugs(true);
        if (!drugId) this.selectedDrug = {};
        toastr['success']('сохранено', 'Успешно')
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.saveLoading = false;
    },
    updateShiftBtn(e, clear = false) {
      const key = e.keyCode;
      this.isShift = clear ? false : key === 16;
    },
    holdShift(id, e) {
      // console.log(this.isShift, id);
      if (!this.isShift) return;
      const drugs = this.$refs.table.rows;
      let arr = [];
      let addRecord = false;
      let loopClose = false;
      drugs.forEach((d) => {
        if (loopClose) return;
        if (d.data.drug.id === +id) {
          loopClose = true;
          return;
        }
        if (this.selectedDrug[d.data.drug.id]) {
          arr = [];
          addRecord = true;
          return;
        }
        if (addRecord) arr.push(d.data.drug.id);
      })
      // console.log(arr);
      arr.forEach((d) => {
        this.selectedDrug[d] = true;
      })
    },
    getDrugsByFilter() {
      const drugs = this.allDrugs.reduce((acc, d) => {
        let addDrug = false;
        if (+this.filter.status) {
          if (+this.filter.status === d.status) addDrug = true;
        } else {
          addDrug = true;
        }
        if (!addDrug) return acc;
        const record = {
          drug: {...d},
          inStores: Math.round((this.inStores[d.id] ?? 0) * 10) / 10,
          sales: Math.round((this.sales[d.id] ?? 0) * 10) / 10,
        }
        const salesQtyPerDay = (record.sales / 60);
        let storeTitle = 'мало';
        if ((salesQtyPerDay * 19) < record.inStores) storeTitle = 'достаточно';
        if ((salesQtyPerDay * 29) < record.inStores) storeTitle = 'много';
        record.storeData = {
          sorting: storeTitle === 'мало' ? 0 : storeTitle === 'достаточно' ? 1 : 2,
          salesQtyPerDay,
          // title: storeTitle,
          title: 'недостаточно',
        }
        if ((salesQtyPerDay * 5) < record.inStores) return acc;
        if (+this.filter.showWithSales === 1 && record.sales <= 0) return acc;
        if (+this.filter.showWithSales === 0 && record.sales > 0) return acc;
        if (record.inStores === 1 && record.storeData.sorting > 0) {
          record.storeData.sorting = 0;
          record.storeData.title = 'мало';
        }
        acc.push(record);
        return acc;
      }, []);
      this.totalRecords = drugs.length;
      return drugs;
    },
    async getDrugs(silent = false) {
      this.loading = !silent;
      const {data} = await api.index('/new/drugs/store/status');
      if (data.success) {
        this.allDrugs = data.drugs;
        this.inStores = data.inStores;
        this.sales = data.sales;
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    }
  }
}
</script>
